<template>
	<div>
		<header class="flex-apart">
			<h1 class="alpha heavy">Search Packs</h1>
		</header>
		<div>
			<loader v-if="!loaded"/>
			<div v-if="loaded" class="section--floating">
				<table-filter :filters="filters"/>
				<div v-if="!items.length" class="nothing-to-see-here">
					<p>Nothing to display.</p>
				</div>
				<v-table v-if="items.length" :loading="gettingModels">
					<thead>
						<tr>
							<th align="left">Address</th>
							<th align="center">Paid</th>
							<th align="center">Status</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</thead>
					<tfoot>
						<tr>
							<th align="left">Address</th>
							<th align="center">Paid</th>
							<th align="center">Status</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</tfoot>
					<tbody>
						<tr v-for="(item, searchPackIndex) in items" :key="searchPackIndex">
							<td>
								<router-link
									:to="{name: 'clients.instructions.show', params: {
										client: item.client.id,
										instruction: item.instruction.id,
									}}"
									v-html="item.address.asLine"/>
							</td>
							<td align="center">
								<bool-icon :value="!item.requiresPayment"/>
							</td>
							<td align="center">
								<status-badge :status="item.status" group="search-pack"/>
							</td>
							<td align="right">
								<v-contextual>
									<v-contextual-option
										v-if="$can('update', item)"
										@click="showSearchPackModal(item)">Edit</v-contextual-option>
								</v-contextual>
							</td>
						</tr>
					</tbody>
					<paginator :links="links" :meta="meta"/>
				</v-table>
			</div>
		</div>
	</div>
</template>
<script>
import Index from "../../../../components";
import showsSearchPackModal from "../../../../mixins/showsSearchPackModal";

let index = new Index("searchPacks");

export default {
	mixins: [
		showsSearchPackModal,
	],

	computed: {
		...index.computed(),
	},

	methods: {
		...index.actions(),
	},

	created() {
		this.getModels();
	},
};
</script>
